const termsContent = {
    title: {
        en: "Terms & Conditions – AppSinTi Dev, LLC",
        es: "Términos y Condiciones – AppSinTi Dev, LLC"
    },
    effectiveDate: {
        en: "Effective Date:",
        es: "Fecha Efectiva:"
    },
    date: {
        en: "May 20, 2025",
        es: "20 de mayo de 2025"
    },
    introduction: {
        en: `These Terms & Conditions ("Terms") govern the use of AppSinTi Dev, LLC's software products and services.`,
        es: `Estos Términos y Condiciones rigen el uso de los productos y servicios de software de AppSinTi Dev, LLC.`
    },
    acceptance: {
        en: "Acceptance of Terms",
        es: "Aceptación de los Términos"
    },
    acceptanceText: {
        en: "By using our services, you agree to be bound by these Terms and our Privacy Policy.",
        es: "Al usar nuestros servicios, aceptas estar sujeto a estos Términos y a nuestra Política de Privacidad."
    },
    eligibility: {
        en: "Eligibility",
        es: "Elegibilidad"
    },
    eligibilityText: {
        en: "You must be 18 or older and authorized to act on behalf of your company to use our B2B services.",
        es: "Debes tener 18 años o más y estar autorizado para actuar en nombre de tu empresa para utilizar nuestros servicios B2B."
    },
    userAccounts: {
        en: "User Accounts",
        es: "Cuentas de Usuario"
    },
    userAccountsText: {
        en: "You are responsible for safeguarding your account credentials. Notify us immediately of any unauthorized use.",
        es: "Eres responsable de proteger las credenciales de tu cuenta. Notifícanos inmediatamente en caso de uso no autorizado."
    },
    serviceDescription: {
        en: "Service Description",
        es: "Descripción del Servicio"
    },
    serviceDescriptionText: {
        en: "We provide tools including:",
        es: "Proporcionamos herramientas que incluyen:"
    },
    serviceTools: [
        {
            en: "Online menu systems",
            es: "Sistemas de menú en línea"
        },
        {
            en: "Customer feedback surveys",
            es: "Encuestas de retroalimentación de clientes"
        },
        {
            en: "Admin dashboards",
            es: "Paneles de administración"
        },
        {
            en: "Reservation tools",
            es: "Herramientas de reservas"
        },
        {
            en: "Monitoring apps and analytics",
            es: "Aplicaciones de monitoreo y análisis"
        }
    ],
    evolvingServices: {
        en: "Services may evolve over time.",
        es: "Los servicios pueden evolucionar con el tiempo."
    },
    restrictions: {
        en: "Restrictions",
        es: "Restricciones"
    },
    restrictionsText: {
        en: "You may not:",
        es: "No puedes:"
    },
    restrictionList: [
        {
            en: "Misuse our services for illegal or unauthorized purposes",
            es: "Utilizar nuestros servicios de manera ilegal o no autorizada"
        },
        {
            en: "Reverse engineer or tamper with the platform",
            es: "Realizar ingeniería inversa o manipular la plataforma"
        },
        {
            en: "Interfere with service integrity or access",
            es: "Interferir con la integridad o el acceso al servicio"
        }
    ],
    payment: {
        en: "Payment and Billing (If Applicable)",
        es: "Pago y Facturación (Si Aplica)"
    },
    paymentText: {
        en: "All fees must be paid in accordance with your service agreement.",
        es: "Todas las tarifas deben pagarse de acuerdo con tu contrato de servicio."
    },
    intellectualProperty: {
        en: "Intellectual Property",
        es: "Propiedad Intelectual"
    },
    intellectualPropertyText: {
        en: "We retain all rights to our software, trademarks, and content. You may not use them without permission.",
        es: "Nos reservamos todos los derechos sobre nuestro software, marcas y contenidos. No puedes usarlos sin permiso."
    },
    disclaimer: {
        en: "Disclaimer of Warranties",
        es: "Renuncia de Garantías"
    },
    disclaimerText: {
        en: "Services are provided \"as is\" without warranties of any kind.",
        es: "Los servicios se proveen \"tal como están\" sin garantías de ningún tipo."
    },
    liability: {
        en: "Limitation of Liability",
        es: "Limitación de Responsabilidad"
    },
    liabilityText: {
        en: "We are not liable for indirect, incidental, or consequential damages.",
        es: "No somos responsables de daños indirectos, incidentales o consecuentes."
    },
    governingLaw: {
        en: "Governing Law",
        es: "Ley Aplicable"
    },
    governingLawText: {
        en: "These Terms are governed by the laws of the State of [Insert State], United States. If you are using our services in Mexico, local consumer protection and data privacy laws may also apply.",
        es: "Estos Términos se rigen por las leyes del estado de [Insert State], Estados Unidos. Si utilizas nuestros servicios en México, también se aplicarán las leyes locales de protección al consumidor y privacidad de datos."
    },
    changes: {
        en: "Changes to Terms",
        es: "Cambios en los Términos"
    },
    changesText: {
        en: "We may update these Terms at any time. Continued use constitutes acceptance of the updated Terms.",
        es: "Podemos actualizar estos Términos en cualquier momento. El uso continuo constituye la aceptación de los Términos actualizados."
    },
    contact: {
        en: "Contact",
        es: "Contacto"
    },
    contactUs: {
        en: "For questions about these Terms, please contact us at ",
        es: "Para preguntas sobre estos Términos, contáctanos en "
    }
};

export default termsContent;